import * as React from "react";
import * as cn from "classnames";

const styles = require("./style.less");

export class DataTableHeader extends React.Component<any, any> {
    render() {
        return (
            <thead className={cn(this.props.className, styles.dataTableHeader)}>
                {this.props.children}
            </thead>
        );
    }
}